require("./databankView.scss");

// @ vendor
const React = require("react");
const PropTypes = require("prop-types");
const { connect } = require("react-redux");
const { withRouter } = require('react-router-dom');
const classNames = require("classnames");

// @ actions
const { hideAppHeader, showAppHeader } = require("actions/screen");

// @ constants and utils
const {
    LOGIN,
    EXIT_APP,
    TEALIUM_EVENT,
    TEALIUM_EVENT_TYPE_RECORD_LINK,
    TEALIUM_EVENT_TYPE_RECORD_PATH,
    getEnvironment,
    getDatabankTranslations
} = require("../../utilities/databank");
const { getName, getFriendlyName } = require("../../utilities/initialization");

// @helpers
const { i18n } = require("core/i18n");
const { PAGE_GENERIC, recordPath, recordLink } = require("utilities/tagging");
const { getLanguage } = require("core/i18n").i18n;

// @sub-views
const { Databank } = require("../../components/databank/databank");

const mapStateToProps = state => {
    return {
        profile: state.profile,
        isDatabankEnabled:
            state.flagBasedFeatures &&
            state.flagBasedFeatures.get("databank-enabled"),
        databankTranslations: getDatabankTranslations(
            state.translations,
            getLanguage()
        )
    };
};

const mapDispatchToProps = dispatch => {
    return {
        hideAppHeader: () => dispatch(hideAppHeader()),
        showAppHeader: () => dispatch(showAppHeader())
    };
};

class DatabankView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            databankLoggedIn: false
        };
    }

    handleLoginEvent() {
        this.props.hideAppHeader();
        this.setState({ databankLoggedIn: true });
    }

    handleExitEvent() {
        this.props.showAppHeader();
        this.setState({ databankLoggedIn: false });
    }

    handleTealiumEvent(message) {
        switch (message.type) {
            case TEALIUM_EVENT_TYPE_RECORD_PATH:
                recordPath(
                    message.payload.nombrePagina,
                    PAGE_GENERIC,
                    message.payload.tipoProceso,
                    message.payload.pasoProceso
                );
                break;
            case TEALIUM_EVENT_TYPE_RECORD_LINK:
                recordLink(
                    message.payload.categoriaEvento,
                    message.payload.accionEvento
                );
            default:
                break;
        }
    }

    handleDatabankEvent(type, message) {
        switch (type) {
            case LOGIN:
                this.handleLoginEvent();
                break;
            case EXIT_APP:
                this.handleExitEvent();
                break;
            case TEALIUM_EVENT:
                this.handleTealiumEvent(message);
            default:
                break;
        }
    }

    render() {
        if (false === this.props.isDatabankEnabled) {
            this.props.history.push("/");
        }

        const language = i18n.getLanguage();
        const friendlyName =
            getName(this.props.profile) || getFriendlyName(this.props.profile);
        const environment = getEnvironment(window.__ENV__);

        const containerClass = classNames("databank__container", {
            "databank__container--logged-in": this.state.databankLoggedIn
        });

        return (
            <div className={containerClass}>
                <Databank
                    language={language}
                    environment={environment}
                    friendlyName={friendlyName}
                    onDatabankEvent={(event, payload) =>
                        this.handleDatabankEvent(event, payload)
                    }
                    messages={this.props.databankTranslations}
                />
            </div>
        );
    }
}

DatabankView.propTypes = {
    hideAppHeader: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    showAppHeader: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    databankTranslations: PropTypes.object.isRequired,
    isDatabankEnabled: PropTypes.bool.isRequired
};

module.exports.constructor = DatabankView;
module.exports.DatabankView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(DatabankView));
